<template>
  <v-card elevation="5" class="mx-auto" max-width="600">
    <v-card-title>{{ esEdicion ? 'Editar Usuario' : 'Nuevo Usuario' }}</v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="formValido">

        <v-text-field
          label="Usuario (login)"
          v-model="datos.usuario"
          :rules="reglas"
          :disabled="esEdicion"
          required
          hide-details="auto"
          class="mb-3"
        />

        <v-text-field
          label="Nombre completo"
          v-model="datos.nombre"
          :rules="reglas"
          required
          hide-details="auto"
          class="mb-3"
        />

        <v-text-field
          label="Teléfono"
          v-model="datos.telefono"
          hide-details="auto"
          class="mb-3"
        />

        <v-text-field
          label="Email"
          v-model="datos.email"
          type="email"
          hide-details="auto"
          class="mb-3"
        />

        <v-select
          label="Rol"
          v-model="datos.rol"
          :items="roles"
          :rules="reglas"
          required
          hide-details="auto"
          class="mb-3"
        />

        <v-text-field
          :label="esEdicion ? 'Nueva clave (dejar vacío para no cambiar)' : 'Clave'"
          v-model="datos.clave"
          :rules="esEdicion ? [] : reglas"
          :required="!esEdicion"
          type="password"
          hide-details="auto"
          class="mb-3"
        />

      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn text @click="$router.push({ name: 'Usuarios' })">Cancelar</v-btn>
      <v-spacer />
      <v-btn color="primary" @click="guardar" :disabled="!formValido">
        {{ esEdicion ? 'Actualizar' : 'Registrar' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'FormUsuario',
  props: {
    usuario: { type: Object, default: () => ({}) }
  },

  data () {
    return {
      formValido: false,
      datos: { usuario: '', nombre: '', telefono: '', email: '', rol: '', clave: '' },
      roles: ['admin', 'cajero', 'recepcion', 'instructor'],
      reglas: [v => !!v || 'Campo requerido']
    }
  },

  computed: {
    esEdicion () {
      return !!(this.usuario && this.usuario.id)
    }
  },

  watch: {
    usuario: {
      immediate: true,
      handler (val) {
        if (val && val.id) {
          this.datos = { ...val, clave: '' }
        }
      }
    }
  },

  methods: {
    guardar () {
      if (!this.$refs.form.validate()) return
      const payload = { ...this.datos }
      // En edición, si clave vacía no la enviamos
      if (this.esEdicion && !payload.clave) delete payload.clave
      this.$emit('registrado', payload)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Usuarios/FormUsuario.vue